import { MaterialTraceability } from "@/dentlab/src/pages/article/material-traceability.component";
import { SheetContentProps } from "../../sheet-provider/sheetRegistry";

interface MaterialTraceabilitySheetContentProps extends SheetContentProps {
	/** Limits the trail to one article; without it all articles are searched. */
	articleCode?: string;
}

export const MaterialTraceabilitySheetContent: React.FC<
	MaterialTraceabilitySheetContentProps
> = ({ articleCode }) => {
	return (
		<div className="flex h-full flex-col">
			<div className="flex flex-row items-baseline gap-2 px-4 py-4">
				<div className="text-lg font-bold">
					Materialienrückverfolgung
				</div>
				{articleCode && (
					<div className="text-md font-mono text-gray-700">
						{articleCode}
					</div>
				)}
			</div>
			<MaterialTraceability articleCode={articleCode} />
		</div>
	);
};
